module.exports = __webpack_public_path__ + "img/4.dc81d55a.png";